import React from 'react';
import { LinkedCard } from '../types';
import { CreditCard, MoreVertical, CheckCircle, XCircle } from 'lucide-react';
interface LinkedCardItemProps {
  card: LinkedCard;
  onEdit?: () => void;
  onRemove?: () => void;
}
export function LinkedCardItem({
  card,
  onEdit,
  onRemove
}: LinkedCardItemProps) {
  const brandColors = {
    visa: 'bg-blue-600',
    mastercard: 'bg-red-600',
    amex: 'bg-blue-800',
    discover: 'bg-orange-600'
  };
  const brandNames = {
    visa: 'Visa',
    mastercard: 'Mastercard',
    amex: 'American Express',
    discover: 'Discover'
  };
  const isExpired = card.expiryYear < new Date().getFullYear() || card.expiryYear === new Date().getFullYear() && card.expiryMonth < new Date().getMonth() + 1;
  return <div className="bg-white border border-gray-200 rounded-xl p-5 hover:shadow-md transition-shadow" data-id="element-107">
      <div className="flex items-start justify-between mb-4" data-id="element-108">
        <div className="flex items-center gap-3" data-id="element-109">
          <div className={`${brandColors[card.brand]} p-2 rounded-lg`} data-id="element-110">
            <CreditCard className="w-5 h-5 text-white" data-id="element-111" />
          </div>
          <div data-id="element-112">
            <p className="font-bold text-gray-900 text-lg" data-id="element-113">
              {brandNames[card.brand]}
            </p>
            <p className="text-gray-500 text-sm" data-id="element-114">•••• {card.last4}</p>
          </div>
        </div>

        <button className="p-1 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-115">
          <MoreVertical className="w-5 h-5 text-gray-400" data-id="element-116" />
        </button>
      </div>

      <div className="flex items-center justify-between" data-id="element-117">
        <div data-id="element-118">
          {card.nickname && <p className="text-sm text-gray-600 mb-1" data-id="element-119">{card.nickname}</p>}
          <p className="text-xs text-gray-400" data-id="element-120">
            Expires {card.expiryMonth.toString().padStart(2, '0')}/
            {card.expiryYear}
          </p>
        </div>

        <div className="flex items-center gap-2" data-id="element-121">
          {card.isActive && !isExpired ? <span className="inline-flex items-center gap-1 px-2 py-1 bg-green-50 text-green-700 rounded-full text-xs font-medium" data-id="element-122">
              <CheckCircle className="w-3 h-3" data-id="element-123" />
              Active
            </span> : <span className="inline-flex items-center gap-1 px-2 py-1 bg-red-50 text-red-700 rounded-full text-xs font-medium" data-id="element-124">
              <XCircle className="w-3 h-3" data-id="element-125" />
              {isExpired ? 'Expired' : 'Inactive'}
            </span>}
        </div>
      </div>
    </div>;
}